import React, { useContext, useEffect, useState } from 'react';
import { useLocalStorage } from '../utils/useLocalStorage';
import { useLocation } from 'react-router-dom';
import { decrypt, encrypt } from '../encrypt';
import FetchApi from '../api/getAxios';
import { useFetch } from '../api/useFetch';


export const UserContext = React.createContext();


export const UserProvider = ({ children }) => {


    const [userBalance, setUserBalance] = useState('');
    const [loadingBalance, setLoadingBalance] = useState(false);
    const [loadingSubscription, setLoadingSubscription] = useState(false);
    const userdata = JSON.parse(localStorage.getItem('accountData'));
    const [bizData, setBizData] = useLocalStorage('businessData');
    const [storedata, setStoreData] = useLocalStorage('storeData');
    const [featureacess, setFeatureAccess] = useLocalStorage('featureAccess');
    const [currentSubscription, setCurrentSubscription] = useState('');
    let userData = decrypt(userdata);
    let businessData = decrypt(bizData);
    let storeData = decrypt(storedata);
    let featureAccess = decrypt(featureacess);

    const stoken = storeData?.stoken;
    const btoken = storeData?.btoken;
    const usertoken = userData?.usertoken;
    // const { usertoken } = userData;
    const location = useLocation();
    let path = location.pathname;

    let data = { btoken };

    const {
        loading: storeLoading, data: allStores, fetchData: getAllStores
    } = useFetch('/getBusinessStores', data);

    function getUserData() {
        // const data = {
        //     usertoken: userData?.usertoken,
        // };
        // FetchApi.post(`/getUserData-bio`, data)
        //     .then((res) => {
        //         if (res.success === false) {
        //         } else {
        //             setuser_data(encrypt(res?.data?.data || ''));
        //         }
        //     });
    }

    useEffect(() => {
        getUserData();
    }, [path]);


    // Get Business Data
    const getBusinessData = async () => {
        const data = {
            btoken, usertoken
        };
        FetchApi.post(`/getBusinessData`, data)
            .then((res) => {
                if (res.success === false) {
                } else {
                    setBizData(encrypt(res.data));
                }
            })
            .catch(() => {
                return;
            });
    };
    // Get Business Data

    // Get Store Data
    const getStoreData = async () => {
        const data = {
            btoken, stoken
        };
        FetchApi.post(`/getStoreData`, data)
            .then((res) => {
                if (res.success === false) {
                } else {
                    setStoreData(encrypt(res.data));
                }
            })
            .catch(() => {
                return;
            });
    };
    // Get Store Data

    // Get User Feature Access
    function getFeatureAccess() {
        const data = {
            btoken, stoken, usertoken
        };
        FetchApi.post(`/user.access.get`, data)
            .then((res) => {
                if (res.success === false) {
                } else {
                    // console.log(res.data);
                    setFeatureAccess(encrypt(res.data));
                }
            })
            .catch((error) => {
                return;
            });
    }
    // Get User Feature Access

    // Get User Balance
    function getUserBalance() {
        const data = {
            usertoken, btoken
        };
        FetchApi.post(`/getUserBalance`, data)
            .then((res) => {
                setLoadingBalance(true);
                if (res.success === false) {
                    setLoadingBalance(false);
                } else {
                    setLoadingBalance(false);
                    setUserBalance(res.data);
                }
            })
            .catch((error) => {
                setLoadingBalance(false);
                return;
            });
    }
    // Get User Balance

    // Get Subscription Details
    function getCurrentSubscription() {
        const data = {
            usertoken, btoken, stoken
        };
        FetchApi.post(`/billing/subscription.current`, data)
            .then((res) => {
                setLoadingBalance(true);
                if (res.success === false) {
                    setLoadingBalance(false);
                } else {
                    setLoadingBalance(false);
                    setCurrentSubscription(res.data);
                }
            })
            .catch((error) => {
                setLoadingBalance(false);
                return;
            });
    }
    // Get Subscription Details

    return (
        <UserContext.Provider value={{
            userData, getUserData,
            usertoken: userData?.usertoken,

            companyData: storeData,

            businessData, btoken, getBusinessData,

            storeLoading, allStores, getAllStores,
            storeData: storeData?.storeData, stoken, getStoreData,

            featureAccess, getFeatureAccess,
            userBalance, getUserBalance, loadingBalance,

            getCurrentSubscription, currentSubscription, loadingSubscription,

        }}>
            {children}
        </UserContext.Provider>
    );
};

// make sure use
export const useUserContext = () => {
    return useContext(UserContext);
};
